import React from 'react';

function NotFound() {
  return (
    <div>
      <h3>404 Not Found!</h3>
      <p>The page you are looking for does not exist</p>
    </div>
  );
}

export default NotFound;